import React, { useState, useRef } from "react";
import { Modal, Tooltip } from "antd";

import {
  deleteIcon,
  EditIcon,
  crossIcon,
  QuickReplyIcon,
  QuickAddBlue,
  QuickAddGrey,
} from "../../../../assets/svg";
import LiveChatService from "../../../../service/LiveChatService";
import QuickReplySection from "./QuickReplySection";

const liveChatService = new LiveChatService();

const QuickReply = (props) => {
  const [state, setState] = useState({
    list: props.quickReplyList,
    edit: false,
    selectedindex: -1,
    newMsg: "",
    newTitle: "",
    error: [],
    success: "",
    addNewMsgSection: false,
  });

  const actionRef = useRef(false);

  const emojiRegex = /([\u2700-\u27BF]|[\uE000-\uF8FF]|[\uD83C-\uDBFF\uDC00-\uDFFF]|\uD83D[\uDC00-\uDE4F]|\uD83D[\uDE80-\uDEFF])/g;

  const validateEmoji = (title, message) => {
    const hasTitleEmoji = emojiRegex.test(title);
    const hasMsgEmoji = emojiRegex.test(message);

    if (hasTitleEmoji && hasMsgEmoji) {
      return "Emojis are not allowed in Title and Message";
    } else if (hasTitleEmoji) {
      return "Emojis are not allowed in Title";
    } else if (hasMsgEmoji) {
      return "Emojis are not allowed in Message";
    }
    return "";
  };

  const onEdit = (item, index) => {
    setState((st) => ({
      ...st,
      edit: true,
      selectedindex: index,
      success: "",
      error: "",
      newMsg: item.quickMessage,
      newTitle: item.quickTitle || "",
    }));
  };

  const openAddNewMsgSection = () => {
    setState((st) => ({
      ...st,
      edit: false,
      success: "",
      error: "",
      addNewMsgSection: true,
    }));
  };

  const closeQuickMsgSection = () => {
    setState((st) => ({
      ...st,
      edit: false,
      success: "",
      error: "",
      newMsg: "",
      newTitle: "",
      addNewMsgSection: false,
    }));
  };

  const onMsgUpdate = async (id) => {
    if (actionRef && actionRef.current) return;
    if (state.error) return;
    else {
      const quickMessage = state.newMsg.trim();
      const quickTitle = state.newTitle.trim();
      const flg = !/\S/.test(quickMessage) || !/\S/.test(quickTitle);
      if (flg) return;
      try {
        actionRef.current = true;
        const obj = {
          id: id,
          quickMessage,
          quickTitle,
        };
        const response = await liveChatService.updateQuickReply(obj);
        const data = await props.getQuickReplyList();
        setState((st) => ({
          ...st,
          edit: false,
          list: data,
          success: response.data.message,
          error: "",
          newMsg: "",
          newTitle: "",
        }));
        actionRef.current = false;
      } catch (err) {
        setState((st) => ({
          ...st,
          error: err.response.data.message,
          success: "",
        }));
        actionRef.current = false;
      }
    }
  };

  const onDelete = async (id) => {
    if (actionRef && actionRef.current) return;
    else {
      try {
        actionRef.current = true;
        const response = await liveChatService.deleteQuickReply(id);
        const data = await props.getQuickReplyList();
        setState((st) => ({
          ...st,
          list: data,
          success: response.data.message,
          error: "",
          selectedindex: -1,
        }));
        actionRef.current = false;
      } catch (err) {
        setState((st) => ({
          ...st,
          error: err.response.data.message,
          success: "",
          selectedindex: -1,
        }));
        actionRef.current = false;
      }
    }
  };

  const saveMsg = async () => {
    if (actionRef && actionRef.current) return;
    if (state.error) return;
    else {
      const message = state.newMsg.trim();
      const title = state.newTitle.trim();
      try {
        actionRef.current = true;
        const response = await liveChatService.saveQuickReply(message, title);
        const data = await props.getQuickReplyList();
        setState((st) => ({
          ...st,
          list: data,
          newMsg: "",
          newTitle: "",
          addNewMsgSection: false,
          success: response.data.message,
          error: "",
        }));
        actionRef.current = false;
      } catch (err) {
        setState((st) => ({
          ...st,
          error: err.response?.data?.message,
          success: "",
        }));
        actionRef.current = false;
      }
    }
  };

  const handleTitleChange = (e) => {
    const temp = e.target.value;
    const error = validateEmoji(temp, state.newMsg);
    setState((st) => ({
      ...st,
      error,
      success: "",
      newTitle: temp,
    }));
  };

  const handleMsgChange = (e) => {
    const temp = e.target.value;
    const error = validateEmoji(state.newTitle, temp);
    setState((st) => ({
      ...st,
      error,
      success: "",
      newMsg: temp,
    }));
  };

  return (
    <div>
      <Modal
        className="custom-modal quick-msg-modal"
        title={
          <>
            Manage Quick Replies
            <Tooltip title="Close">
              <span className="close-icon" onClick={props.hideQuickReply}>
                {crossIcon}
              </span>
            </Tooltip>
          </>
        }
        mask={false}
        visible={props.isVisible}
        centered
        footer={null}
      >
        <section className="quick-reply">
          <section className="add-new-section">
            <div>Replies</div>
            <div
              className="add-icon"
              onClick={state.addNewMsgSection ? null : openAddNewMsgSection}
            >
              {state.addNewMsgSection ? <QuickAddGrey /> : <QuickAddBlue />}
            </div>
          </section>
          <section className="quick-reply-body">
            {state.addNewMsgSection && (
              <QuickReplySection
                newTitle={state.newTitle}
                newMsg={state.newMsg}
                handleMsgChange={handleMsgChange}
                handleTitleChange={handleTitleChange}
                saveMsg={saveMsg}
                closeQuickMsgSection={closeQuickMsgSection}
              />
            )}
            <article className="quick-reply-wrapper">
              {state.list.length === 0 &&
                !state.addNewMsgSection && (
                  <div className="no-quick-reply">
                    <div className="icon">
                      <QuickReplyIcon />
                    </div>

                    <div>Add a new quick reply to see it here.</div>
                  </div>
                )}
              <ul className="quick-reply-list-container">
                {state.list.map((item, index) => {
                  return (
                    <li
                      className={
                        state.edit && state.selectedindex === index
                          ? "edit-quick-reply"
                          : "quick-reply-list"
                      }
                    >
                      {state.edit && state.selectedindex === index ? (
                        <QuickReplySection
                          newTitle={state.newTitle}
                          newMsg={state.newMsg}
                          handleMsgChange={handleMsgChange}
                          handleTitleChange={handleTitleChange}
                          saveMsg={onMsgUpdate}
                          closeQuickMsgSection={closeQuickMsgSection}
                          quickReplyId={item.id}
                        />
                      ) : (
                        <p className="list-item">
                          {item.quickTitle ? (
                            <span className="list-title">
                              {item.quickTitle}
                            </span>
                          ) : (
                            <span className="no-title">Untitled</span>
                          )}

                          <span className="list-message">
                            {item.quickMessage}
                          </span>
                        </p>
                      )}
                      <section
                        className={`quick-reply-actions ${state.edit &&
                          "edit"}`}
                      >
                        {!state.edit && (
                          <>
                            <span
                              onClick={() => onEdit(item, index)}
                              className="action-icon"
                            >
                              <EditIcon />
                            </span>
                            <span
                              onClick={() => onDelete(item.id)}
                              className="action-icon"
                            >
                              {deleteIcon}
                            </span>
                          </>
                        )}
                      </section>
                    </li>
                  );
                })}
              </ul>
            </article>
          </section>
        </section>
        {state.error || state.success ? (
          <div>
            {state.error && <div className="error-text">{state.error}</div>}
            {state.success && (
              <div className="success-msg">{state.success}</div>
            )}
          </div>
        ) : null}
      </Modal>
    </div>
  );
};

export default QuickReply;
